import {
  GroupBase,
  OptionBase,
  SelectInstance,
  AsyncProps as Props,
  AsyncSelect as Select,
} from 'chakra-react-select';
import { forwardRef, Ref } from 'react';

export interface SelectOption extends OptionBase {
  text: string;
  value: string | number;
}

export interface AsyncSelectProps
  extends Props<SelectOption, boolean, GroupBase<SelectOption>> {
  name: string;
  label: string;
}

export const AsyncSelect = forwardRef<SelectInstance, AsyncSelectProps>(
  ({ label, ...props }, ref) => (
    <Select
      {...props}
      aria-label={label}
      errorBorderColor='errors.200'
      getOptionLabel={(option) => (option as SelectOption)?.text || ''}
      loadingMessage={() => 'Buscando...'}
      noOptionsMessage={() => 'Nenhum resultado encontrado.'}
      ref={
        ref as Ref<
          SelectInstance<SelectOption, boolean, GroupBase<SelectOption>>
        >
      }
      chakraStyles={{
        control: (provided) => ({
          ...provided,
          borderColor: 'background.200',
          borderRadius: 2,
          cursor: 'pointer',
          fontSize: 14,
          fontWeight: 600,

          _hover: {
            borderColor: 'background.300',
          },
          _focus: {
            borderColor: 'background.300',
          },
        }),
        singleValue: (provided) => ({
          ...provided,
          color: 'primary.500',
        }),
        multiValue: (provided) => ({
          ...provided,
          color: 'primary.500',
          bgColor: 'purple.200',
        }),
        option: (provided, state) => ({
          ...provided,
          color: 'text.900',
          fontSize: 14,
          fontWeight: state.isSelected ? 700 : 400,
          _hover: {
            bgColor: 'primary.150',
          },
        }),
        placeholder: (provided) => ({
          ...provided,
          color: 'text.200',
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          padding: 2,
          bgColor: 'transparent',
          color: 'primary.500',
        }),
        clearIndicator: (provided) => ({
          ...provided,
          color: 'primary.500',
          fontSize: 10,
        }),
      }}
    />
  )
);

AsyncSelect.displayName = 'AsyncSelect';
